import React from 'react';
import {
    TouchableOpacity,
    Platform,
    TouchableNativeFeedback,
    View,
    StyleSheet
} from 'react-native';
import TouchableItem from './TouchableItem';
import DefaultText from './DefaultText';
import DefaultIcon from './DefaultIcon';

import Colors from '../constants/Colors';

const BackButton = props => {
    return (
        <TouchableItem
            onSelectItem={props.onClick}
            style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', height: 50, width: 70 }}>            
            <DefaultIcon
                name='ios-arrow-back'
                size={30}
                color={Colors.darkBlue}
            />
            <DefaultText style={{ color: Colors.darkBlue, fontFamily: 'lato-bold', marginLeft: 10 }}
            >
                Back
                </DefaultText>
        </TouchableItem>
    )
};

const styles = StyleSheet.create({
});

export default BackButton;

